module.exports = "<ng-container #mainContainer></ng-container>"